import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import kebabCase from 'lodash/kebabCase.js';

/**
 * Generate the following data attributes
 * ( data-object-id, data-object-type, data-[dynamic attribute name from optionalAttributes] )
 * Use on element: {...dataAttribsForEl(context, { someAttribueKey: someAttributeValue })}
 *
 * @param {DataAttributeContext} context The object containing the id and type
 * @param {object | undefined} optionalAttributes Optional object of attributes
 * { attributeName: attributeValue }
 * example: { action: 'some-action' } becomes data-action="some-action"
 * works with single word, camel, or kebab
 * @returns {DataAttributes} Object with all properties that contain `data-`
 */
var dataAttribsForEl = function dataAttribsForEl() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    id: '',
    type: ''
  };
  var optionalAttributes = arguments.length > 1 ? arguments[1] : undefined;
  var dataObject = {
    'data-object-id': context.id,
    'data-object-type': context.type
  };
  if (optionalAttributes) {
    Object.entries(optionalAttributes).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      dataObject["data-".concat(kebabCase(key))] = kebabCase(value);
    });
  }
  return dataObject;
};
export { dataAttribsForEl };